import { cn, Modal, PrimaryButton, FeedBackMessage } from '@artprov/design-system'

export default function ModalUpdateDetalleNomina({
  openModal,
  onCloseModal,
  mensaje = '',
  subtitulo = '',
  icon = '',
  titulo = '',
  hintsInputMonth = [{}],
  onAcceptModal,
  disabledBtnAceptar = true,
}) {
  return (
    <Modal.Container
      open={openModal}
      className={cn('overflow-x-hidden')}
      onClose={onCloseModal}
      closeOnClickOutside={false}
    >
      <Modal.Content height="auto" width="448px" className={cn('overflow-x-hidden')}>
        <Modal.Header>
          <Modal.Title className="pl-2"></Modal.Title>
          <Modal.Close onClose={() => onCloseModal(false)} />
        </Modal.Header>
        <Modal.Body className={cn('overflow-x-hidden')}>
          <FeedBackMessage
            icon={icon}
            title={titulo}
            description={mensaje}
            iconStyles={icon == 'check_circle' ? 'text-success-10' : 'text-warning-10'}
            titleStyles="text-primary-10"
            descriptionStyles="w-96 text-balance"
          ></FeedBackMessage>
        </Modal.Body>
        <Modal.Footer className="flex justify-center items-center h-full">
          <Modal.CancelButton
            onClick={() => {
              onCloseModal(false)
            }}
          >
            Cancelar
          </Modal.CancelButton>
          <PrimaryButton
            className="mx-2"
            size="small"
            onClick={() => {
              //   onCloseModal(false)
              if (onAcceptModal) {
                onAcceptModal()
              }
            }}
            classNameIcon="text-tertiary-100"
          >
            Aceptar
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  )
}
